import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    variantTypes: Array,
    selectionUrl: { type: String, default: '/products/select_variant_values' },
    generateVariantsUrl: { type: String, default: '/products/generate_variants' },
    options: { type: Object, default: {} }, // initial value is existing variants. Update with new/removed selections and send to reload frame
  }

  static targets = ["frame", "variantFields", "check", "variantIndex", 'datatable', 'variantStockQty']

  connect() {
    this.stockMap = {}
    if (this.hasDatatableTarget) {
      $(this.datatableTarget).on('draw.dt', function () {
        document.querySelector('#products-datatable').addEventListener('shown.bs.dropdown', this.fetchVariants)
      })
    }
  }

  variantTypesValueChanged() {
    // fetch form
    // called on connect and typeChanged
    this.load()
  }

  load() {
    if (this.hasFrameTarget) {
      const params = new URLSearchParams()
      Object.entries(this.optionsValue).forEach(([variant, value]) => {
        params.append(`variant_types[${variant}]`, value)
      })
      params.append("variant_type_ids", this.variantTypesValue)
      this.frameTarget.src = `${this.selectionUrlValue}?${params}`
      this.frameTarget.reload()
    }
  }

  sumVariantQuantitiesPerWarehouse(warehouseId) {
    const inputs = document.querySelectorAll(`.variant-stock-qty[data-warehouse-id='${warehouseId}']`);
    let total = 0;
    inputs.forEach(input => {
      total += parseInt(input.value) || 0;
    });
    return total;
  }

  updateStockQuantity(event) {
    const input = event.target;
    const stockId = input.dataset.stockId;
    const warehouseId = input.dataset.warehouseId;
    const variantId = input.dataset.variantId;
    const quantity = parseInt(input.value) || 0

    // Initialize nested structure if missing
    if (!this.stockMap[warehouseId]) this.stockMap[warehouseId] = {}
    this.stockMap[warehouseId][variantId] = quantity

    // Recalculate total for that warehouse
    const total = this.sumVariantQuantitiesPerWarehouse(warehouseId)

    console.log(`Warehouse ${warehouseId} total: ${total}`)
    console.log('Stock map:', this.stockMap)
  }

  updateTypes(event) {
    // whenever a type is selected/deselected fetch form with selected values
    if (event.target.checked) {
      // add to variantTypes value
      if (this.variantTypesValue.length == 3) {
        alert('maximum of 3 options allowed')
        event.target.checked = false
        return
      }
      this.variantTypesValue = Array.from(new Set(this.variantTypesValue.concat([+event.target.value])))
    } else {
      // remove from variantTypes value
      this.variantTypesValue = this.variantTypesValue.filter(v => v !== +event.target.value)
    }
  }

  updateTypeValues(event) {
    // construct map of variant_type_id: [...variant_type_values]
    this.optionsValue = { ...this.optionsValue, [event.params.typeId]: Array.from(event.target.selectedOptions).map(option => option.value)}
  }

  generateVariants(event) {
    event.preventDefault()
    const formData = new FormData(event.target.form)
    formData.set("_method", "post")
    let options = {
      method: "POST",
      body: formData
    }
    fetch(this.generateVariantsUrlValue, options)
    .then(response => response.text())
    .then(html => this.variantFieldsTarget.innerHTML = html)
  }

  closeModal(event) {
    $('#stockModal').modal('hide')
  }

  restoreChecked(event) {
    if (this.hasCheckTarget) {
      for (const check of this.checkTargets) {
        check.checked = this.variantTypesValue.includes(parseInt(check.value))
      }
    }
  }

  fetchVariants(event) {
    if (this.hasVariantIndexTarget) {
      this.variantIndexTarget.reload()
    }
  }
}
